/** End the current user's session */
export const sessionEndSpec = {
    uri: '/t/[tenant]/session/end',
    method: 'POST',
};
